var _excluded = ["id", "isInverse", "maxLength", "showCharCount", "stateValue"],
  _excluded2 = ["aria-describedby", "actionOnly", "affixRight", "affixLeft", "align", "autoExpand", "className", "disabled", "hasTrim", "hasError", "hasWarning", "id", "inputSize", "isBlock", "isInverse", "isLoading", "helpText", "errorText", "inputMode", "isMaskedInput", "label", "labelAction", "labelProps", "name", "hidden", "placeholder", "preventPaste", "showCharCount", "maxLength", "regex", "required", "successText", "warningText", "rows", "size", "type", "onChange", "onPaste", "onBlur", "onKeyDown", "onFocus", "readOnly", "shape", "utils", "value"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef, useEffect, useState, useRef, useLayoutEffect } from 'react';
import InverseContext from '../../utilities/inverse-context';
import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import Label from './../label';
import Loader from '../loader';
import Hint from '../hint';
import Icon from '../icon/';
import Type from '../type';
import combineRefs from '../../utilities/combine-refs';
import StyledFormField from './form-field.styles';
import StyledFormFieldAffixButton from './styles/form-field.affix-button.styles';
import StyledFormFieldAffixText from './styles/form-field.affix-text.styles';
import StyledFormFieldCharCount from './styles/form-field.char-count.styles';
import StyledFormFieldHintWrapper from './styles/form-field.hint-wrapper.styles';
import StyledFormFieldHintText from './styles/form-field.hint-text.styles';
import StyledFormFieldInput from './styles/form-field.input.styles';
import StyledFormFieldLabel from './styles/form-field.label.styles';
import StyledFormFieldStateWrapper from './styles/form-field.state-wrapper.styles';
import StyledFormFieldTextarea from './styles/form-field.textarea.styles';
import StyledFormFieldWrapper from './styles/form-field.wrapper.styles';
import { StyledCacheWrapper } from '../../styles';
function regexHandler(value, pattern) {
  var character = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (value) {
    var reg = new RegExp(pattern);
    var isValid = reg.test(value);
    return isValid ? value.replace(pattern, character) : value;
  }
}
function isRegex(value, regex) {
  return value ? regexHandler(value, regex) : '';
}
function autoExpandHandler(autoExpand, rows, formField) {
  if (autoExpand && !rows) {
    formField.current.style.cssText = 'height: auto;';
    var height = formField.current.scrollHeight;
    formField.current.style.cssText = "height: ".concat(height, "px;");
  }
}
var defaultProps = {
  actionOnly: false,
  'aria-describedby': '',
  className: '',
  disabled: false,
  errorText: '',
  hasError: false,
  helpText: '',
  hasWarning: false,
  isLoading: false,
  inputMode: null,
  isMaskedInput: false,
  hasTrim: false,
  label: '',
  labelAction: null,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onPaste: function onPaste() {},
  name: '',
  placeholder: '',
  readOnly: false,
  required: true,
  size: null,
  type: 'text',
  value: '',
  affixRight: [],
  affixLeft: [],
  shape: 'square',
  id: '',
  preventPaste: false,
  regex: [],
  rows: null,
  maxLength: null,
  minLength: null,
  warningText: '',
  showCharCount: false,
  successText: '',
  autoExpand: false,
  hidden: false,
  isInverse: 'auto',
  isBlock: true,
  inputSize: 20,
  labelProps: {},
  align: 'left',
  utils: {}
};
var propTypes = {
  /** Prevent input into the form field unless the action trigger has been selected to allow it to be editied. */
  actionOnly: PropTypes.bool,
  /** add affix items to the right of an input field. {{icon: String, content: String, onButtonClick: Function, inverse: Boolean}[]} */
  affixRight: PropTypes.array,
  /** add affix items to the left of an input field. {{icon: String, content: String, onButtonClick: Function, inverse: Boolean}[]} */
  affixLeft: PropTypes.array,
  /** Accessibility text. */
  'aria-describedby': PropTypes.string,
  /** Auto expand the textarea height */
  autoExpand: PropTypes.bool,
  /** Set to "textarea" to render textarea. Default: "type='text'". */
  type: PropTypes.string,
  /** Specifies the form fields placeholder text. */
  placeholder: PropTypes.string,
  /** Specifies an onChange event to be triggered when dropdown value changes. */
  onChange: PropTypes.func,
  /** Will prevent the user from pasting a value. */
  preventPaste: PropTypes.bool,
  /** The input ID represents the JSON property that the input value is mapped to. */
  id: PropTypes.string,
  /** Specifies the form fields label text. */
  label: PropTypes.node,
  /** Specifies a button or action associated with the form near the label. */
  labelAction: PropTypes.object,
  /** Disables the formfield */
  disabled: PropTypes.bool,
  /** Prefill value to be supplied to the text input field. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Hide the formfield */
  hidden: PropTypes.bool,
  /** Input's read only state */
  readOnly: PropTypes.bool,
  /** Specifies whether the form field is required. */
  required: PropTypes.bool,
  /** Prevents matching characters from being input and replaces with an empty string unless preceded by ^. */
  regex: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** To define height of rows displayed in the Textarea variant. */
  rows: PropTypes.number,
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** Toggles the error error state. */
  hasError: PropTypes.bool,
  /** Unobtrusively styled warning text to appear below formField to aid user input. */
  warningText: PropTypes.node,
  /** Unobtrusively styled text to appear below formField to aid user input. */
  helpText: PropTypes.node,
  /** Unobtrusively styled text to appear below formField to describe the error when validated. */
  errorText: PropTypes.node,
  /** Specify a maximum number of characters for the input. */
  maxLength: PropTypes.number,
  /** Specify a minimum number of characters for the input. */
  minLength: PropTypes.number,
  /** If you've specified a maxLength, you can show a hint below the FormField which will count down the amount characters left. */
  showCharCount: PropTypes.bool,
  /** Unobtrusively styled green text to appear below formField to recommend user input. */
  successText: PropTypes.node,
  /** Toggles the warning error state. */
  hasWarning: PropTypes.bool,
  /** Adds a loading underline to the field. This should be used with disabled or readonly. */
  isLoading: PropTypes.bool,
  /** Trims empty whitespace from the begining and end of a text string. */
  hasTrim: PropTypes.bool,
  /** Used to trigger appropriate keyboard on mobile devices */
  inputMode: PropTypes.oneOf(['none', 'text', 'url', 'numeric', 'decimal', 'tel', 'email', 'search']),
  /** Used to hijack control over the onChange event, because the maskedInput needs to handle it internally. */
  isMaskedInput: PropTypes.bool,
  /** Specifies onBlur event, when the focus is removed from FormField. */
  onBlur: PropTypes.func,
  /** Specifies onBlur event, when the focus is added to FormField. */
  onFocus: PropTypes.func,
  /** Specifies onKeyDown event, when a key is pressed down while focused on the FormField */
  onKeyDown: PropTypes.func,
  /** Specifies onPaste event, when content is pasted into the FormField. */
  onPaste: PropTypes.func,
  /** Sets the name of the FormField input. */
  name: PropTypes.string,
  /** Sets the size of the formfield. ('lg' ,'sm' or null/default) */
  size: PropTypes.string,
  /** FormField Shape - pill: fully rounded at each end, square: square corners. */
  shape: PropTypes.oneOf(['pill', 'square']),
  /** Set to true if field is on a dark background. */
  isInverse: PropTypes.oneOf(['auto', true, false]),
  /** Component will span the width of it's parent. */
  isBlock: PropTypes.bool,
  /** Set the width of the input based on number of characters. */
  inputSize: PropTypes.number,
  /** Pass extra props to the field's label */
  labelProps: PropTypes.object,
  /** Align the text in the form field */
  align: PropTypes.oneOf(['left', 'right', 'center']),
  /** Add utility props for styling */
  utils: PropTypes.object
};
var affixItemContent = function affixItemContent(arr, item, side, key, i) {
  if (item.content) {
    return /*#__PURE__*/React.createElement(StyledFormFieldAffixText, {
      isFirst: i === 0,
      isHollow: item.hollow,
      isElement: /*#__PURE__*/React.isValidElement(item.content),
      isMiddle: i > 0 && i + 1 < arr.length,
      isLast: i === arr.length - 1,
      key: key,
      side: side
    }, item.content);
  }
};
var affixButtonContent = function affixButtonContent(disableButton, key, item, onButtonClickHandler, i, arr) {
  return /*#__PURE__*/React.createElement(StyledFormFieldAffixButton, {
    "aria-label": item.ariaLabel,
    disabled: disableButton || item.disable,
    hasIconOnly: true,
    hollowStyles: item.hollow,
    isFirst: i === 0,
    isHollow: true,
    isIcon: item.icon,
    key: key,
    onClick: onButtonClickHandler(item.onButtonClick),
    type: "button",
    isPrimary: true,
    ref: item.ref,
    isLast: i === arr.length - 1
  }, item.icon ? /*#__PURE__*/React.createElement(Icon, {
    icon: item.icon || 'calendar',
    alt: item.title || 'Calendar'
  }) : item.content, /*#__PURE__*/React.createElement(Type, {
    utils: {
      srOnly: true
    }
  }, item.icon ? item.content : ''));
};
function renderAffix(arr, isDisabled, isReadOnly, isActionOnly, side, onButtonClickHandler) {
  var disableButton = isActionOnly && !isDisabled ? false : isDisabled || isReadOnly;
  return arr.map(function (item, i) {
    var key = "affix-".concat(i);
    if (item.onButtonClick) {
      return affixButtonContent(disableButton, key, item, onButtonClickHandler, i, arr);
    }
    return affixItemContent(arr, item, side, key, i);
  });
}
function renderHintText(_ref) {
  var helpText = _ref.helpText,
    errorText = _ref.errorText,
    hasErrorState = _ref.hasErrorState,
    warningText = _ref.warningText,
    hasWarningState = _ref.hasWarningState,
    successText = _ref.successText;
  if (errorText && hasErrorState) {
    return /*#__PURE__*/React.createElement(Type, {
      role: "alert",
      variant: "critical",
      weight: "bold"
    }, errorText);
  }
  if (warningText && hasWarningState) {
    return /*#__PURE__*/React.createElement(Type, {
      variant: "caution",
      weight: "bold"
    }, warningText);
  }
  if (successText) {
    return /*#__PURE__*/React.createElement(Type, {
      variant: "success",
      weight: "bold"
    }, successText);
  }
  return helpText || null;
}
function renderHint(_ref2) {
  var id = _ref2.id,
    isInverse = _ref2.isInverse,
    maxLength = _ref2.maxLength,
    showCharCount = _ref2.showCharCount,
    stateValue = _ref2.stateValue,
    other = _objectWithoutProperties(_ref2, _excluded);
  var renderedHintText = renderHintText(other);
  return /*#__PURE__*/React.createElement(StyledFormFieldHintWrapper, null, renderedHintText && /*#__PURE__*/React.createElement(StyledFormFieldHintText, null, /*#__PURE__*/React.createElement(Hint, {
    id: "".concat(id, "__hintText"),
    isInverse: isInverse,
    type: "default",
    text: renderedHintText
  })), showCharCount && maxLength && /*#__PURE__*/React.createElement(StyledFormFieldCharCount, {
    id: "".concat(id, "_charCount")
  }, /*#__PURE__*/React.createElement(Hint, {
    isInverse: isInverse,
    text: "".concat(stateValue ? stateValue.length : 0, "/").concat(maxLength)
  })));
}
function getAriaDescribedby(_ref3) {
  var errorText = _ref3.errorText,
    hasErrorState = _ref3.hasErrorState,
    warningText = _ref3.warningText,
    hasWarningState = _ref3.hasWarningState,
    successText = _ref3.successText,
    helpText = _ref3.helpText,
    id = _ref3.id,
    ariaDescribedby = _ref3.ariaDescribedby;
  if (errorText && hasErrorState || warningText && hasWarningState || successText || helpText) {
    return "".concat(id, "__hintText ").concat(ariaDescribedby);
  }
  return ariaDescribedby;
}
var renderTextArea = function renderTextArea(_ref4) {
  var autoExpand = _ref4.autoExpand,
    disabled = _ref4.disabled,
    formField = _ref4.formField,
    forwardedRef = _ref4.forwardedRef,
    id = _ref4.id,
    inputMode = _ref4.inputMode,
    isLoading = _ref4.isLoading,
    maxLength = _ref4.maxLength,
    name = _ref4.name,
    onBlurHandler = _ref4.onBlurHandler,
    onFocusHandler = _ref4.onFocusHandler,
    onChangeSwitch = _ref4.onChangeSwitch,
    onKeyDownHandler = _ref4.onKeyDownHandler,
    onPasteHandler = _ref4.onPasteHandler,
    other = _ref4.other,
    placeholder = _ref4.placeholder,
    readOnly = _ref4.readOnly,
    required = _ref4.required,
    rows = _ref4.rows,
    setAriaDescribedby = _ref4.setAriaDescribedby,
    stateValue = _ref4.stateValue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledFormFieldTextarea, _extends({
    "aria-describedby": setAriaDescribedby,
    autoExpand: autoExpand && !rows,
    disabled: disabled,
    id: id,
    inputMode: inputMode,
    maxLength: maxLength,
    name: name,
    onBlur: onBlurHandler,
    onFocus: onFocusHandler,
    onChange: onChangeSwitch,
    onKeyDown: onKeyDownHandler,
    onPaste: onPasteHandler,
    placeholder: placeholder,
    readOnly: readOnly,
    ref: combineRefs(formField, forwardedRef),
    required: required,
    rows: rows,
    value: stateValue
  }, other)), /*#__PURE__*/React.createElement(StyledFormFieldStateWrapper, null), isLoading && /*#__PURE__*/React.createElement(Loader, null));
};
var renderInput = function renderInput(_ref5) {
  var actionOnly = _ref5.actionOnly,
    affixLeft = _ref5.affixLeft,
    affixRight = _ref5.affixRight,
    disabled = _ref5.disabled,
    formField = _ref5.formField,
    forwardedRef = _ref5.forwardedRef,
    id = _ref5.id,
    inputMode = _ref5.inputMode,
    inputSize = _ref5.inputSize,
    isLoading = _ref5.isLoading,
    maxLength = _ref5.maxLength,
    name = _ref5.name,
    onBlurHandler = _ref5.onBlurHandler,
    onFocusHandler = _ref5.onFocusHandler,
    onButtonClickHandler = _ref5.onButtonClickHandler,
    onChangeSwitch = _ref5.onChangeSwitch,
    onKeyDownHandler = _ref5.onKeyDownHandler,
    onPasteHandler = _ref5.onPasteHandler,
    other = _ref5.other,
    placeholder = _ref5.placeholder,
    readOnly = _ref5.readOnly,
    required = _ref5.required,
    setAriaDescribedby = _ref5.setAriaDescribedby,
    stateValue = _ref5.stateValue,
    type = _ref5.type;
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderAffix(affixLeft, disabled, readOnly, actionOnly, 'left', onButtonClickHandler), /*#__PURE__*/React.createElement(StyledFormFieldInput, _extends({
    actionOnly: actionOnly,
    "aria-describedby": setAriaDescribedby,
    disabled: disabled,
    id: id,
    inputMode: inputMode,
    maxLength: maxLength,
    name: name,
    onBlur: onBlurHandler,
    onFocus: onFocusHandler,
    onChange: onChangeSwitch,
    onKeyDown: onKeyDownHandler,
    onPaste: onPasteHandler,
    placeholder: placeholder,
    readOnly: actionOnly || readOnly ? true : false,
    ref: combineRefs(formField, forwardedRef),
    required: required,
    size: inputSize,
    type: type,
    value: stateValue
  }, other)), /*#__PURE__*/React.createElement(StyledFormFieldStateWrapper, null), renderAffix(affixRight, disabled, readOnly, actionOnly, 'right', onButtonClickHandler), isLoading && /*#__PURE__*/React.createElement(Loader, null));
};

/**
 *
 * @ignore @description
 * ## FormField Component
 * An Input Field is a form element that allows users to type in freeform information.
 *
 * @ignore @see Mesh: [FormField Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/forms-formfield--default)
 *
 * @ignore @example
 * ```jsx
 * import { FormField } from 'mesh-component-library';
 *
 * <FormField {...props}/>
 * ```
 * @type React.ForwardRefRenderFunction<React.FunctionComponent, propTypes>
 */

var FormField = /*#__PURE__*/forwardRef(
// eslint-disable-next-line complexity
function (_ref6, forwardedRef) {
  var ariaDescribedby = _ref6['aria-describedby'],
    actionOnly = _ref6.actionOnly,
    affixRight = _ref6.affixRight,
    affixLeft = _ref6.affixLeft,
    align = _ref6.align,
    autoExpand = _ref6.autoExpand,
    className = _ref6.className,
    disabled = _ref6.disabled,
    hasTrim = _ref6.hasTrim,
    hasError = _ref6.hasError,
    hasWarning = _ref6.hasWarning,
    id = _ref6.id,
    inputSize = _ref6.inputSize,
    isBlock = _ref6.isBlock,
    isInverse = _ref6.isInverse,
    isLoading = _ref6.isLoading,
    helpText = _ref6.helpText,
    errorText = _ref6.errorText,
    inputMode = _ref6.inputMode,
    isMaskedInput = _ref6.isMaskedInput,
    label = _ref6.label,
    labelAction = _ref6.labelAction,
    labelProps = _ref6.labelProps,
    name = _ref6.name,
    hidden = _ref6.hidden,
    placeholder = _ref6.placeholder,
    preventPaste = _ref6.preventPaste,
    showCharCount = _ref6.showCharCount,
    maxLength = _ref6.maxLength,
    regex = _ref6.regex,
    required = _ref6.required,
    successText = _ref6.successText,
    warningText = _ref6.warningText,
    rows = _ref6.rows,
    size = _ref6.size,
    type = _ref6.type,
    onChange = _ref6.onChange,
    onPaste = _ref6.onPaste,
    onBlur = _ref6.onBlur,
    onKeyDown = _ref6.onKeyDown,
    onFocus = _ref6.onFocus,
    readOnly = _ref6.readOnly,
    shape = _ref6.shape,
    utils = _ref6.utils,
    value = _ref6.value,
    other = _objectWithoutProperties(_ref6, _excluded2);
  var formField = useRef();
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    stateValue = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(hasError),
    _useState4 = _slicedToArray(_useState3, 2),
    hasErrorState = _useState4[0],
    setHasError = _useState4[1];
  var _useState5 = useState(hasWarning),
    _useState6 = _slicedToArray(_useState5, 2),
    hasWarningState = _useState6[0],
    setHasWarning = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isInputFocused = _useState8[0],
    setIsInputFocused = _useState8[1];
  var _useState9 = useState(!value),
    _useState10 = _slicedToArray(_useState9, 2),
    isInputEmpty = _useState10[0],
    setIsInputEmpty = _useState10[1];
  var uid = id || uniqueId('form-field-');
  useLayoutEffect(function () {
    autoExpandHandler(autoExpand, rows, formField);
    setIsInputEmpty(!stateValue);
  }, [stateValue]);
  useEffect(function () {
    var regexVal = isRegex(value, regex);
    setValue(regexVal);
  }, []);
  useEffect(function () {
    var regexVal = isRegex(value, regex);
    setValue(regexVal);
    setHasError(hasError);
    setHasWarning(hasWarning);
  }, [value, hasError, hasWarning, autoExpand]);
  var onChangeHandler = function onChangeHandler(event) {
    var val = event.target.value;
    var newValue = isRegex(val, regex);
    event.target.value = newValue;
    setValue(newValue);
    onChange(event);
  };
  var onButtonClickHandler = function onButtonClickHandler(onButtonClick) {
    return function (event) {
      onButtonClick(event, {
        value: stateValue,
        hasError: hasErrorState,
        hasWarning: hasWarningState
      }, id);
    };
  };
  var onKeyDownHandler = function onKeyDownHandler(event) {
    onKeyDown(event);
  };
  var onFocusHandler = function onFocusHandler(event) {
    setIsInputFocused(true);
    onFocus(event);
  };
  var onBlurHandler = function onBlurHandler(event) {
    if (hasTrim) {
      trimField(event);
    }
    setIsInputFocused(false);
    onBlur(event);
  };
  var trimField = function trimField(event) {
    var val = event.target.value.trim();
    setValue(val);
  };
  var onPasteHandler = function onPasteHandler(event) {
    if (preventPaste) {
      event.preventDefault();
      return;
    }
    onPaste(event);
  };
  var setAriaDescribedby = getAriaDescribedby({
    errorText: errorText,
    hasErrorState: hasErrorState,
    warningText: warningText,
    hasWarningState: hasWarningState,
    successText: successText,
    helpText: helpText,
    id: id,
    ariaDescribedby: ariaDescribedby
  });
  var onChangeSwitch = isMaskedInput ? onChange : onChangeHandler;
  var useIsInverse = React.useContext(InverseContext);
  if (isInverse !== 'auto') {
    useIsInverse = isInverse;
  }
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(StyledFormField, {
    affixLeftItems: affixLeft,
    affixRightItems: affixRight,
    align: align,
    className: className,
    hasAffix: affixRight.length > 0 || affixLeft.length > 0,
    hasAffixLeft: affixLeft.length > 0,
    hasAffixRight: affixRight.length > 0,
    hasError: hasErrorState,
    hasSuccess: !!successText,
    hasWarning: hasWarningState,
    hidden: hidden,
    isBlock: isBlock,
    isDisabled: disabled,
    isInputEmpty: isInputEmpty,
    isInputFocused: isInputFocused,
    isInverse: useIsInverse,
    isLabelless: !label,
    isLoading: isLoading,
    isReadOnly: actionOnly || readOnly,
    isRequired: required,
    shape: shape,
    size: size,
    type: type,
    utils: utils
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledFormFieldLabel, null, /*#__PURE__*/React.createElement(Label, _extends({
    htmlFor: uid,
    text: label,
    required: required,
    action: labelAction
  }, labelProps, {
    isInverse: useIsInverse
  }))), /*#__PURE__*/React.createElement(StyledFormFieldWrapper, null, type === 'textarea' ? renderTextArea({
    autoExpand: autoExpand,
    disabled: disabled,
    formField: formField,
    forwardedRef: forwardedRef,
    id: uid,
    inputMode: inputMode,
    isLoading: isLoading,
    maxLength: maxLength,
    name: name,
    onBlurHandler: onBlurHandler,
    onFocusHandler: onFocusHandler,
    onChangeSwitch: onChangeSwitch,
    onKeyDownHandler: onKeyDownHandler,
    onPasteHandler: onPasteHandler,
    other: other,
    placeholder: placeholder,
    readOnly: readOnly,
    required: required,
    rows: rows,
    setAriaDescribedby: setAriaDescribedby,
    stateValue: stateValue
  }) : renderInput({
    actionOnly: actionOnly,
    affixLeft: affixLeft,
    affixRight: affixRight,
    disabled: disabled,
    formField: formField,
    forwardedRef: forwardedRef,
    id: uid,
    inputMode: inputMode,
    inputSize: inputSize,
    isLoading: isLoading,
    maxLength: maxLength,
    name: name,
    onBlurHandler: onBlurHandler,
    onFocusHandler: onFocusHandler,
    onButtonClickHandler: onButtonClickHandler,
    onChangeSwitch: onChangeSwitch,
    onKeyDownHandler: onKeyDownHandler,
    onPasteHandler: onPasteHandler,
    other: other,
    placeholder: placeholder,
    readOnly: readOnly,
    required: required,
    setAriaDescribedby: setAriaDescribedby,
    stateValue: stateValue,
    type: type
  }))), renderHint({
    errorText: errorText,
    hasErrorState: hasErrorState,
    id: id,
    helpText: helpText,
    isInverse: isInverse,
    maxLength: maxLength,
    showCharCount: showCharCount,
    successText: successText,
    warningText: warningText,
    hasWarningState: hasWarningState,
    stateValue: stateValue
  })));
});
FormField.displayName = 'FormField';
FormField.propTypes = propTypes;
FormField.defaultProps = defaultProps;
export default FormField;